import {FormikElement} from 'core/enums/formik-controller.enum';
import {MaxValidationLimits, SelectInputFixedAtOptions, SelectInputIndexOptions} from 'core/_consts';
import Controller from 'shared/components/FormikController';
import {useFormikContext} from 'formik';

const FixedSpread = () => {
  const {setFieldValue} = useFormikContext();

  return (
    <div className="FormSlide__section flexWrap">
      <div className="FormSlide__section gap5">
        <Controller
          control={FormikElement.SELECT}
          options={SelectInputIndexOptions}
          label="Index"
          name="fixedSpread.index"
        />
        <Controller
          control={FormikElement.NUMERIC_INPUT}
          width="80px"
          label="Spread"
          setFieldValue={setFieldValue}
          sign="+"
          reversed
          preventionLimit={MaxValidationLimits.percent}
          name="fixedSpread.spread"
        />
        <p className="FormSlide__sign mb10">%</p>
      </div>
      <div className="FormSlide__section flexWrap">
        <Controller
          control={FormikElement.SELECT}
          options={SelectInputFixedAtOptions}
          label="Fixed at"
          name="fixedSpread.fixedAt"
        />
        <div className="FormSlide__section">
          <Controller
            control={FormikElement.NUMERIC_INPUT}
            width="80px"
            preventionLimit={MaxValidationLimits.percent}
            label="Rate Floor"
            setFieldValue={setFieldValue}
            sign="%"
            name="fixedSpread.rateFloor"
          />
          <Controller
            control={FormikElement.NUMERIC_INPUT}
            width="80px"
            label="Index Floor"
            preventionLimit={MaxValidationLimits.percent}
            setFieldValue={setFieldValue}
            sign="%"
            name="fixedSpread.indexFloor"
          />
        </div>
      </div>
    </div>
  );
};

export default FixedSpread;
